import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateDiscordServerMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
  input: Types.UpdateDiscordServerInput;
}>;

export type UpdateDiscordServerMutation = {
  __typename?: 'Mutation';
  updateDiscordServer: {
    __typename?: 'DiscordServer';
    id: any;
    name: string;
    createdAt: any;
    owner?:
      | { __typename?: 'Team'; id: any; name: string }
      | { __typename?: 'User'; id: any; email: string }
      | null;
  };
};

export const UpdateDiscordServerDocument = gql`
  mutation UpdateDiscordServer($id: UUID!, $input: UpdateDiscordServerInput!) {
    updateDiscordServer(id: $id, input: $input) {
      id
      owner {
        ... on User {
          id
          email
        }
        ... on Team {
          id
          name
        }
      }
      name
      createdAt
    }
  }
`;
export type UpdateDiscordServerMutationFn = Apollo.MutationFunction<
  UpdateDiscordServerMutation,
  UpdateDiscordServerMutationVariables
>;

/**
 * __useUpdateDiscordServerMutation__
 *
 * To run a mutation, you first call `useUpdateDiscordServerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscordServerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscordServerMutation, { data, loading, error }] = useUpdateDiscordServerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDiscordServerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDiscordServerMutation,
    UpdateDiscordServerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateDiscordServerMutation,
    UpdateDiscordServerMutationVariables
  >(UpdateDiscordServerDocument, options);
}
export type UpdateDiscordServerMutationHookResult = ReturnType<
  typeof useUpdateDiscordServerMutation
>;
export type UpdateDiscordServerMutationResult =
  Apollo.MutationResult<UpdateDiscordServerMutation>;
export type UpdateDiscordServerMutationOptions = Apollo.BaseMutationOptions<
  UpdateDiscordServerMutation,
  UpdateDiscordServerMutationVariables
>;
